/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["icon-selector{background-color:#fff;padding:15px;border-radius:4px;width:490px;max-width:90vw;min-height:390px;overflow:auto;position:relative;text-align:center;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}icon-selector .mat-icon-button{transition:-webkit-transform .1s ease-in-out;transition:transform .1s ease-in-out;transition:transform .1s ease-in-out,-webkit-transform .1s ease-in-out}icon-selector .mat-icon-button:hover{-webkit-transform:scale(1.6);transform:scale(1.6)}"];
export { styles as styles };
